import { use, useEffect, useState } from "react";
import Layout from "../../components/layoutMasterConfig/layoutMaster";
import { setupAPIclient } from "../../services/setupAPIclientAuth";
import { toast } from "react-toastify";
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import DataTable, { TableColumn } from "react-data-table-component";
import { apiClientMater } from "../../services/setupClientMaster/apiClientMaster";
import ConfigDataFirestore from "../../servicesFirebase/configDataFirestore";

import edit from '../../components/dashboard/img/favicon/editar.png';

import { getAuth } from "firebase/auth";



type DataRow = {
    id: number;
    name: string;
    email: string;
    number: number;
    address: string; 
    neighborhood: string;
    postal_code: string; 
    city: string; 
    state: string; 
    active: boolean;
    car_model?: string; 
    is_registered_in_app?: boolean; 
    pet_quantity?: number; 
    transport_type?: string; 
    createdAt?: string; 
    updatedAt?: string;    
    categories?: string[];
    password: string;
    access_permission_request: boolean;
    //masterId: number;
    cnpj?: string;
    cpf?: string;
};



function ConfigMasterSubmasterPage(){

    const [messages, setMessages] = useState([
      { id: 1, text: "Olá! Como posso te ajudar?", sender: "bot" },
    ]);


  
  
    // const [showDivregistered, showDivRegistered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showFormUpdate, setShowFormUpdate] = useState(false);


    const [formData, setFormData] = useState<{
      name: string;
      email: string;
      address: string;
      neighborhood: string;
      postal_code: string;
      cnpj: string;
      cpf: string;
      city: string;
      state: string;
      password: string;
      number: string;
      categories: string[];
      access_permission_request: boolean;
      active: boolean;
    }>({
      name: '',
      email: '',
      address: '',
      neighborhood: '',
      postal_code: '',
      cnpj: '',
      cpf: '',
      city: '',
      state: '',
      password: '',
      number: '',
      categories: [],
      access_permission_request:false,
      active:false
    });
    
    
  
      // Função para manipular a mudança nos inputs
      function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
        const { name, value } = e.target;  
        setFormData({
          ...formData,  
          [name]: value, 
        });
      };
    
  
      async function handleChangePostalcode(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
  
        setFormData({
          ...formData,               
          postal_code: e.target.value
        });
  
        const apiclient =  Zip_Code_Api(e.target.value)
  
        const response =  await apiclient.get("")
    
          if(response && response.data ){
            setFormData({
              ...formData,neighborhood: response.data.bairro,
              state: response.data.estado,
              city: response.data.localidade,
              address: response.data.logradouro
            });
          }
      }
  
      // Função para formatar CPF
      function maskCPF(e: React.ChangeEvent<HTMLInputElement>) {
        let cpf = e.target.value;
        cpf = cpf.replace(/\D/g, ''); // Remove tudo o que não é número
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
        cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
         setFormData({ ...formData, cpf });
      }
    
      // Função para formatar número de telefone
      function maskPhone(e: React.ChangeEvent<HTMLInputElement>){
        let phone = e.target.value;
        phone = phone.replace(/\D/g, ''); // Remove tudo o que não é número
        phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
        phone = phone.replace(/(\d{5})(\d{1,4})$/, '$1-$2');
         setFormData({ ...formData, number: phone });
      };
    
  
      const resetForm = (enableModal:boolean) => {
        setFormData({
          name: '',
          email: '',
          address: '',
          neighborhood: '',
          postal_code: '',
          cnpj: '',
          cpf: '',
          city: '',
          state: '',
          password: '',
          number: '',
          categories: [],
          access_permission_request: false,
          active: false,
        });

        if(enableModal){
            setShowModal(true)
        }

      };
      
    function handleChangeCategory(event: React.ChangeEvent<HTMLSelectElement>) {


      //const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
      //setSelectedCategories(selectedValues);
     
  
      const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value); 
      setFormData((prevData) => ({
        ...prevData,
        categories: selectedOptions,
      }));
    }
  
    async function handleSubmit(e: React.FormEvent<HTMLFormElement>){
        e.preventDefault();

        if(formData.email === ""){
          toast.warning("O campo e-mail deve ser preenchido!")
        }else if(formData.password === ""){
          toast.warning("O campo de senha deve ser preenchido!")
        }else if(formData.number === ""){
          toast.warning("O campo número de telefone deve ser preenchido!")
        }else{
          try {
            const ApiClient = setupAPIclient();
        
            const response = await ApiClient.post("/register_submaster", {
                name: formData.name,
                email: formData.email,
                address: formData.address,
                neighborhood: formData.neighborhood,
                postal_code: formData.postal_code,
                city: formData.city,
                state: formData.state,  
                categories: formData.categories,
                active: false,
                number: formData.number,
                password: formData.password,
                access_permission_request: false,
                masterId: 1,
                cnpj: formData.cnpj,
                cpf: formData.cpf
            });
        
            // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
            if (response.status >= 200 && response.status < 300) {
                if (response.data.has_data) {
                    toast.success("Cadastrado com sucesso! 🎉");
        
                    resetForm(false);
                    //showDivRegistered(false);

                    setTimeout(() => {
                      window.location.reload();
                  }, 1000);
                } else {
                    toast.error("Já existe um usuário cadastrado com os mesmos dados. Por favor, verifique o CPF, CNPJ e e-mail! ❌");
                }
            } else {
                throw new Error(`Erro inesperado: ${response.status}`);
            }
        } catch (error) {
            console.error("Erro ao registrar submaster:", error);
        
            // Exibe a mensagem de erro mais detalhada possível
            const errorMessage =  "Erro ao cadastrar usuário. Tente novamente.";
            
            toast.error(errorMessage);
        }
        }

       
    };

    const [filterText, setFilterText] = useState(""); 
    const [Iduser, setShowIduser] = useState(0);
    const [getData, setgetData] = useState<DataRow[]>([]);


    const columns: TableColumn<DataRow>[] = [
        {
          name: "Nome",
          selector: (row) => row.name,
          sortable: true,
        },
        {
          name: "E-mail",
          selector: (row) => row.email,
          sortable: true,
        },
        {
          name: "Telefone",
          selector: (row) => row.number,
          sortable: true,
        },
        {
          name: 'Ações',
          cell: (row: { id: number }) => (
            <button className="btn btn-sm btn-light" onClick={() => handleButtonUpdate(row.id)}>
              <img src={edit} width={20} alt="Editar" />
            </button>
          ),
          ignoreRowClick: true, 
          allowOverflow: true,
          button: true
        },
      ];
 
  


      const handleButtonUpdate = (id: number) => {

        const selectedItem = getData.find((item) => item.id === id);
    
        console.log(`Item com ID ${id} foi clicado! ${selectedItem?.city}`);
    
    
        setShowIduser(id)
    
        setFormData({
            name: selectedItem?.name ?? '',
            email: selectedItem?.email ?? '',
            address: selectedItem?.address ?? '',
            neighborhood: selectedItem?.neighborhood ?? '',
            postal_code: selectedItem?.postal_code ?? '',
            city: selectedItem?.city ?? '',
            state: selectedItem?.state ?? '',
            categories: selectedItem?.categories ?? [], 
            active: selectedItem?.active ?? false,
            number: String(selectedItem?.number ?? ''), 
            password: '', // Ajuste conforme necessário
            access_permission_request: false, 
            //masterId: 1, 
            cnpj: selectedItem?.cnpj ?? '',
            cpf: selectedItem?.cpf ?? '',
        });
        
    
    
        setShowFormUpdate(true)


        handleGetCategories()
      }


      const filteredData = getData.filter(
        (item) =>
          item.cnpj?.toLowerCase().includes(filterText.toLowerCase()) ||
          item.cpf?.toLowerCase().includes(filterText.toLowerCase()) 
      );



    const handleSubmitUpdate = async () => {



      if(formData.email === ""){
        toast.warning("O campo e-mail deve ser preenchido!")
      }else if(formData.number === ""){
        toast.warning("O campo número de telefone deve ser preenchido!")
      }else{
        const loadingToast = toast.info("Processando... aguarde", {
          autoClose: false, 
        });
        toast.dismiss(loadingToast);
        try {
          const ApiClient = apiClientMater();
          const response = await ApiClient.post(`/crud/update/Submaster/${Iduser}`, {
              name: formData.name,
              address: formData.address,
              neighborhood: formData.neighborhood,
              postal_code: formData.postal_code,
              city: formData.city,
              state: formData.state,  
              categories: formData.categories,
              number_active: false,
              number: formData.number,
            
              access_permission_request: false,
              masterId: 1,
              cnpj: formData.cnpj,
              cpf: formData.cpf
          });
          if (response.status >= 200 && response.status < 300) {
            toast.success("Atualizado com sucesso!");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            throw new Error(`Erro inesperado: ${response.status}`);
          }
        } catch (error) {
            console.error("Erro ao atualizar usuário:", error);
            toast.dismiss(loadingToast);
            toast.error("Erro ao atualizar o usuário. Tente novamente.");
        }
      }

     
      
    }

    
    const [categories, setCategories] = useState<{ id: number; categories: string }[]>([]);
    //const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  

    const handleGetCategories = async () => {
      const ApiClient = apiClientMater();
      const response = await ApiClient.post("/crud/Category");
      setCategories(response.data.map((item: any) => ({
        id: item.id, 
        categories: Array.isArray(item.categories) 
          ? item.categories.join(", ") 
          : item.categories ?? "Sem categoria", 
    })))
    }
    

    useEffect(() => {
        const handlegetActivisionData = async () => {
          const ApiClient = apiClientMater();
          const response = await ApiClient.post("/crud/Submaster");
    
            console.log(response.data)

            const formattedData = response.data.map((item: any) => ({
                id: item.id,
                name: item.name,
                email: item.email,
                number: item.number,
                address: item.address,
                neighborhood: item.neighborhood,
                postal_code: item.postal_code,
                city: item.city,
                state: item.state,
                car_model: item.car_model ?? '', 
                is_registered_in_app: item.is_registered_in_app ?? false,
                pet_quantity: item.pet_quantity ?? 0,
                transport_type: item.transport_type ?? '',
                active: item.active ?? false,
                access_permission_request: item.access_permission_request ?? false,
                categories: item.categories ?? [],
                masterId: item.masterId ?? null,
                cnpj: item.cnpj ?? '',
                cpf: item.cpf ?? '',
                password: item.password ?? '',
                createdAt: item.createdAt,
                updatedAt: item.updatedAt,
            }));

          setgetData(formattedData)
        }
        

      handlegetActivisionData();

    }, []);


    return (
        <Layout>
         

         <div>
          {!showFormUpdate ? (
            <div>

                <div className=' mr-3 mt-3 mb-3'>
                    <button className='btn btn-success' onClick={() => {
                      handleGetCategories();

                      resetForm(true);
                    }}>
                        Cadastrar Empresa
                    </button>
                </div>

                <input
                  type="text"
                  placeholder="Filtrar por CNPJ ou CPF"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    width: "18%",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
                <DataTable  
                  columns={columns}
                  data={filteredData}
                  pagination
                  onSelectedRowsChange={(selected) =>
                    console.log("Selected Rows: ", selected.selectedRows)
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: 'Página',
                    rangeSeparatorText: 'de',
                    selectAllRowsItem: true,
                    selectAllRowsItemText: 'Selecionar todos'
                  }}
                />

            </div>
            ) :  <div className='card mt-3'>
              <div className="modal-body ">
                      <form  method="POST">
                      <div className="row">
                          <div className="form-group col-md-6 mt-2">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="name"
                              id="name"
                              placeholder="Nome"
                              value={formData.name}
                              onChange={handleChange}
                              required
                          />
                          </div>
                          <div className="form-group col-md-6 mt-2">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="email"
                              id="email"
                              placeholder="E-mail"
                              value={formData.email}
                              onChange={handleChange}
                              disabled
                              required
                          />
                          </div>
                      </div>
                      <div className="form-row">
                          <div className="form-group col-md-6">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="address"
                              id="address"
                              placeholder="Endereço"
                              value={formData.address}
                              onChange={handleChange}
                              disabled
                          />
                          </div>
                          <div className="form-group col-md-6">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="neighborhood"
                              id="neighborhood"
                              placeholder="Bairro"
                              value={formData.neighborhood}
                              onChange={handleChange}
                              required
                              disabled
                          />
                          </div>
                      </div>
                      <div className="form-row">
                          <div className="form-group  col-md-6">

                          <p className='control_cep'>Para buscar o bairro e o endereço automaticamente, digite o CEP.</p>
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="postal_code"
                              id="postal_code"
                              placeholder="CEP"
                              value={formData.postal_code}
                              onChange={handleChangePostalcode}
                              required
                          />
                          </div>
                          <div className="form-group col-md-6">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="cnpj"
                              id="cnpj"
                              placeholder="CNPJ"
                              value={formData.cnpj}
                              onChange={handleChange}
                          />
                          </div>
                      </div>
                      <div className="form-row">
                          <div className="form-group col-md-6">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="cpf"
                              id="cpf"
                              placeholder="CPF"
                              value={formData.cpf}
                              onChange={maskCPF}
                              required
                          />
                          </div>
                          <div className="form-group col-md-6">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="city"
                              id="city"
                              placeholder="Cidade"
                              value={formData.city}
                              onChange={handleChange}
                              required
                              disabled
                          />
                          </div>
                      </div>
                      <div className="form-row ">
                          <div className="form-group col-md-5">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="state"
                              id="state"
                              placeholder="Estado"
                              disabled
                              value={formData.state}
                              onChange={handleChange}
                              required
                          />
                          </div>
                          <div className="form-group col-md-2">
                          <input
                              type="password"
                              className="fadeIn second form-control"
                              name="password"
                              id="password"
                              placeholder="Senha"
                              disabled
                              required
                              autoComplete="current-password"
                          />
                          </div>

                          <div className="form-group col-md-5">
                          <input
                              type="text"
                              className="fadeIn second form-control"
                              name="number"
                              id="number"
                              placeholder="Número de Telefone"
                              value={formData.number}
                              onChange={maskPhone}
                              required
                          />
                          </div>

                      

                      </div>
                      <div className="form-group col-md-12 d-flex flex-column align-items-center">
                          <label htmlFor="categories">Categorias</label>
                          <select
                          className="fadeIn second form-control"
                          name="categories"
                          id="categories"
                          multiple
                          required
                          value={formData.categories}
                          onChange={handleChangeCategory} // Atualiza o estado ao selecionar
                        >
                          {categories.map((value) => (
                            <option key={value.id} value={value.id}>
                              {value.categories}
                            </option>
                          ))}
                        </select>
                      </div>
                      </form>
                      <div className="modal-footer">
                      <button className="btn btn-secondary" onClick={() => setShowFormUpdate(false)}>Fechar</button>
                          <button className="btn btn-success" onClick={handleSubmitUpdate}>Editar</button>
                      </div>
              </div>
            </div>
          }
        </div>

          {/* Modal do Bootstrap */}
          {(showModal && !showFormUpdate) && (
            <div className="modal fade show d-block">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Cadastrar Empresa</h5>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className="modal-body">
                            <form  method="POST">
                    <div className="form-row">
                        <div className="form-group col-md-6 mt-2">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="name"
                            id="name"
                            placeholder="Nome"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div className="form-group col-md-6 mt-2">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="email"
                            id="email"
                            placeholder="E-mail"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="address"
                            id="address"
                            placeholder="Endereço"
                            value={formData.address}
                            onChange={handleChange}
                            disabled
                        />
                        </div>
                        <div className="form-group col-md-6">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="neighborhood"
                            id="neighborhood"
                            placeholder="Bairro"
                            value={formData.neighborhood}
                            onChange={handleChange}
                            required
                            disabled
                        />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group  col-md-6">

                        <p className='control_cep'>Para buscar o bairro e o endereço automaticamente, digite o CEP.</p>
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="postal_code"
                            id="postal_code"
                            placeholder="CEP"
                            value={formData.postal_code}
                            onChange={handleChangePostalcode}
                            required
                        />
                        </div>
                        <div className="form-group col-md-6">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="cnpj"
                            id="cnpj"
                            placeholder="CNPJ"
                            value={formData.cnpj}
                            onChange={handleChange}
                        />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="cpf"
                            id="cpf"
                            placeholder="CPF"
                            value={formData.cpf}
                            onChange={maskCPF}
                            required
                        />
                        </div>
                        <div className="form-group col-md-6">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="city"
                            id="city"
                            placeholder="Cidade"
                            value={formData.city}
                            onChange={handleChange}
                            required
                            disabled
                        />
                        </div>
                    </div>
                    <div className="form-row ">
                        <div className="form-group col-md-5">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="state"
                            id="state"
                            placeholder="Estado"
                            disabled
                            value={formData.state}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div className="form-group col-md-2">
                        <input
                            type="password"
                            className="fadeIn second form-control"
                            name="password"
                            id="password"
                            placeholder="Senha"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            autoComplete="current-password"
                        />
                        </div>

                        <div className="form-group col-md-5">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="number"
                            id="number"
                            placeholder="Número de Telefone"
                            value={formData.number}
                            onChange={maskPhone}
                            required
                        />
                        </div>

                    

                    </div>
                    <div className="form-group col-md-12 d-flex flex-column align-items-center">
                        <label htmlFor="categories">Categorias</label>
                          <select
                          className="fadeIn second form-control"
                          name="categories"
                          id="categories"
                          multiple
                          required
                          value={formData.categories}
                          onChange={handleChangeCategory} // Atualiza o estado ao selecionar
                        >
                          {categories.map((value) => (
                            <option key={value.id} value={value.id}>
                              {value.categories}
                            </option>
                          ))}
                        </select>
                    </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Fechar</button>
                           

                            <button className="btn btn-success" onClick={handleSubmit}>Salvar</button>

                        </div>
                    </div>
                </div>
            </div>
          )}

          {/* Background escuro (overlay) */}
          {(showModal && !showFormUpdate) && <div className="modal-backdrop fade show"></div>}




        </Layout>
    )


    
}


export default ConfigMasterSubmasterPage
